import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logoImage from '../assets/logo.png';

const Navigation: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-18 py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src={logoImage}
              alt="Cyvantix Solutions logo"
              className="h-12 w-auto object-contain"
            />
            <span style={{ fontFamily: "'Exo 2', sans-serif" }} className="text-xl font-bold text-[#001a4d] tracking-wide leading-tight">
              Cyvantix Solutions
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="px-4 py-2 text-[#001a4d] hover:text-[#0B8A8F] font-medium transition-colors rounded-lg hover:bg-teal-50 text-sm"
              >
                {link.name}
              </Link>
            ))}
            <a
              href="mailto:info@cyvantixsolutions.com?subject=Book%20Free%20CyvaCheck"
              className="ml-3 px-5 py-2.5 bg-[#0B8A8F] text-white font-bold rounded-lg hover:bg-[#097a7f] transition-all shadow-sm hover:shadow-md text-sm"
            >
              Book Free CyvaCheck
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 text-[#001a4d]"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden border-t border-gray-100 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block px-4 py-3 text-[#001a4d] hover:text-[#0B8A8F] hover:bg-teal-50 rounded-lg font-medium transition-colors text-sm"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="mailto:info@cyvantixsolutions.com?subject=Book%20Free%20CyvaCheck"
              className="block px-4 py-3 mt-2 bg-[#0B8A8F] text-white font-bold rounded-lg hover:bg-[#097a7f] text-center transition-all text-sm"
              onClick={() => setIsOpen(false)}
            >
              Book Free CyvaCheck
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
